<template>
  <v-dialog
    v-model="dialog"
    max-width="750"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs10>
            <h2 class="text-xs-left display-3 sz_grafit--text ma-0 mt-1">
              {{ $t('family_card.turn_off.header') }}
            </h2>
          </v-flex>
          <v-flex xs2>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <p class="f-1">
          {{ $t('family_card.turn_off.title') }}
        </p>
        <v-checkbox
          v-for="(item, index) in reasons"
          :key="`${index}-${item.id}`"
          v-model="turnOff"
          :value="item.id"
          :label="item.name"
          type="checkbox"
          off-icon=""
          on-icon="check"
        />
        <v-text-field
          v-if="showField"
          v-model="reasonText"
          v-validate="validationRules.get('required_field_max_180')"
          :error-messages="errors.collect('required_field_max_180')"
          data-vv-name="required_field_max_180"
          :placeholder="$t('label.other_placeholder')"
          :data-vv-as="$t('label.other')"
        />
        <div
          v-if="reasonsId === 2 || additionalField"
          class="mt-3"
        >
          <p class="f-16 px-1 mb-2 required-block">
            {{ $t('sheet.turn_off_desc') }}
          </p>
          <v-textarea
            :key="'decisionReason'"
            v-model="decisionReason"
            v-validate="validationRules.get('decision_non_inclusion')"
            :placeholder="$t('placeholders.add_text')"
            :error-messages="errors.collect('decision_non_inclusion_2')"
            :data-vv-as="' '"
            data-vv-name="decision_non_inclusion_2"
            auto-grow
          />
        </div>
        <v-divider />
      </v-card-text>
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[mobileScreen ? 'mt-2' : 'mr-4']"
          >
            <a @click="canceled()">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              :loading="loading"
              :disabled="!isDisabled"
              color="sz_violet"
              @click="send()"
            >
              {{ $t('buttons.send') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validationRules from '@/constants/validationRules';

export default {
    name: 'TurnOffModal',
    props: {
        visible: {
            default: false,
            type: Boolean
        },
        familyId: {
            required: true
        },
        reasonsId: {
            default: 1,
            type: Number
        },
        additionalField: {
            default: false,
            type: Boolean
        },
        getData: {
            default: true,
            type: Boolean
        }
    },
    data () {
        return {
            dialog: false,
            turnOff: [],
            reasonText: '',
            decisionReason: null,
            validationRules,
            loading: false,
            TURN_OFF_REASONS_ID: 1,
            TURN_OFF_SHEET_REASONS_ID: 2,
            TURN_OFF_REASONS_NO_VOLUNTEERS_ID: 3
        };
    },
    computed: {
        reasons () {
            let reasons = [];
            if (this.reasonsId === 1) {
                reasons = this.$store.getters['defaultApi/getTurnOffReasons'];
            }
            if (this.reasonsId === 2) {
                reasons = this.sheetReasons;
            }
            if (this.reasonsId === 3) {
                reasons = this.$store.getters['defaultApi/getNoVolunteersTurnOffReasons'];
            }
            const other = reasons.filter((el) => {
                return el.id === 4;
            });
            reasons = reasons.filter((el) => {
                return el.id !== 4;
            });
            if (other?.length > 0) {
                reasons.push(other[0]);
            }
            return reasons;
        },
        sheetReasons () {
            return this.$store.getters['sheet/getExclusionReasons'];
        },
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        showField () {
            return this.turnOff?.includes(4);
        },
        payloadData () {
            if (this.turnOff?.length === 0) {
                return null;
            }
            const other = this.turnOff?.find((item) => {
                return item === 4;
            });
            if (other) {
                if (this.reasonsId === 2 || this.additionalField) {
                    return {
                        exclusion_reasons: this.turnOff,
                        description: this.reasonText,
                        explanation: this.decisionReason
                    };
                }
                return { exclusion_reasons: this.turnOff, description: this.reasonText };
            }
            if (this.reasonsId === 2 || this.additionalField) {
                return { exclusion_reasons: this.turnOff, explanation: this.decisionReason };
            }
            if (this.reasonsId === 3) {
                return { exclusion_reasons: this.turnOff };
            }
            return {
                exclusion_reasons: this.turnOff,
                description: null,
                explanation: this.decisionReason
            };
        },
        isDisabled () {
            if (this.payloadData) {
                if (this.$validator.errors.count()) {
                    return false;
                }
                if (this.reasonsId === 3) {
                    return this.turnOff?.length > 0;
                }
                if (this.showField) {
                    if (this.reasonsId === 2 || this.additionalField) {
                        return (
                            this.turnOff?.length > 0 &&
              this.reasonText.length > 0 &&
              this.decisionReason?.length > 0
                        );
                    }
                    return this.turnOff?.length > 0 && this.reasonText.length > 0;
                }
                return (
                    this.turnOff?.length > 0 && this.decisionReason?.length > 0
                );
            }
            return false;
        }
    },
    watch: {
        visible (val) {
            this.dialog = val;
        },
        dialog () {
            if (!this.dialog) {
                this.$emit('close', false);
                this.turnOff = [];
                this.reasonText = '';
            }
        },
        reasonsId: {
            handler (val) {
                const fetchExclusionReasons = {
                    [this.TURN_OFF_REASONS_ID]: () => this.$store.dispatch('defaultApi/getTurnOffReasons'),
                    [this.TURN_OFF_SHEET_REASONS_ID]: () => {
                        if (this.getData) {
                            this.$store.dispatch('sheet/getExclusionReasons');
                        }
                    },
                    [this.TURN_OFF_REASONS_NO_VOLUNTEERS_ID]: () => this.$store.dispatch('defaultApi/getNoVolunteersTurnOffReasons')
                };

                if (fetchExclusionReasons[val]) {
                    fetchExclusionReasons[val]();
                }
            },
            immediate: true
        }
    },
    methods: {
        closeDialog () {
            this.dialog = false;
            this.$emit('close', false);
        },
        canceled () {
            this.closeDialog();
        },
        send () {
            this.loading = true;
            this.$store
                .dispatch('family/turnOffFamily', { id: this.familyId, data: this.payloadData })
                .then(({ data }) => {
                    this.$store.commit('family/setFamily', data.data);
                })
                .then(() => {
                    this.$emit('reload');
                })
                .finally(() => {
                    this.loading = false;
                    this.closeDialog();
                });
        }
    }
};
</script>

<style scoped></style>
